import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';

import PublishedBy, { PublishedByProps } from './PublishedBy';
import ShareArticleActions from './ShareArticleActions';
import { Channel } from '../../shared/types';
import {
    getPrintTextPrimaryColor,
    getPrintTextSecondaryColor,
} from '../../utils/print-theme.utils';

export interface ArticleHeaderProps {
    title: string;
    summary: string;
    id: string;
    publishedData: PublishedByProps;
    channel?: Channel;
    chartsArticle?: boolean;
}

const ArticleHeader: FC<ArticleHeaderProps> = ({
    title,
    summary,
    id,
    publishedData,
    channel,
    chartsArticle,
}) => {
    return (
        <>
            <Box
                sx={(theme) => {
                    return {
                        mb: 2,
                        '@media print': {
                            '& h1': {
                                color: getPrintTextPrimaryColor(theme),
                            },
                        },
                    };
                }}
                id={'article-page-title'}
            >
                <Typography variant="h3">{title}</Typography>
            </Box>
            <Typography
                variant="body1"
                sx={[
                    {
                        color: 'text.secondary',
                    },
                    (theme) => {
                        return {
                            mb: 2,
                            '@media print': {
                                color: getPrintTextSecondaryColor(theme),
                            },
                        };
                    },
                ]}
            >
                <Box component="span" id={'article-page-summary'}>
                    {summary}
                </Box>
            </Typography>
            <Box id={'article-page-published-by'} sx={{ mb: 2 }}>
                <PublishedBy
                    date={publishedData.date}
                    publisher={publishedData.publisher}
                    momentInTimeFormat={publishedData.momentInTimeFormat}
                    showEditDate={publishedData.showEditDate}
                    editDate={publishedData.editDate}
                    channel={channel}
                    disabledPublishedDate={!chartsArticle}
                />
            </Box>
            {!chartsArticle ? (
                <ShareArticleActions articleTitle={title} articleId={id} />
            ) : (
                <></>
            )}
        </>
    );
};

export default ArticleHeader;
